import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { IoIosAdd } from "react-icons/io";
import { FaSearch } from "react-icons/fa";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { SlArrowDown } from "react-icons/sl";

export default function Navbar({printAllUsers, setUserCheck, setAddCheck, sortValue, setSortValue, setViolationTitleInput, violationTitleInput, violations, setCurrPage, setBulkCheck, setEditContent}) {
    const navigate = useNavigate();
     const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const ITEM_HEIGHT = 48;
    const options = [
        {name: 'Manage Users'},
        {name: 'Edit Content'},
    ];

    const handleMenuChange = (option) => {
        if (option === "Manage Users") {
            printAllUsers();
            setAddCheck(false);
            setUserCheck(true);
            setBulkCheck(false);
            setEditContent(false);
        }   

        else if (option === "Edit Content") {
            setAddCheck(false);
            setUserCheck(false);
            setBulkCheck(false);
            setEditContent(true);
        }
    }

    const handleSetAdd = () => {
        setUserCheck(false);
        setAddCheck(true);
        setBulkCheck(false);
        setEditContent(false);
    }

    const handleBulkCheck = () => {
        setBulkCheck(true);
        setUserCheck(false);
        setAddCheck(false);
        setEditContent(false);
    }

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    return (
        <div className="header-container" style={{marginBottom: "10px"}}>
            {/*<h1 style={{paddingRight: "15px", paddingLeft: "5px"}}>Admin Dashboard</h1>*/}
            <FaSearch style={{marginRight: "5px", marginTop:"2px"}} className="search-icon"/>
            <Autocomplete size="small" disablePortal options={violations.map((option) => option.arsCode)} className="search-bar"
                renderInput={(params) => (
                    <TextField {...params} label="Search Violations" sx={{ "& .MuiInputLabel-root.Mui-focused": { color: "black" }, "& .MuiOutlinedInput-root": { 
                        "&.Mui-focused fieldset": { border: "1px solid black", color: "black" }, }, backgroundColor: "white", borderRadius: '4px'}}/>
                    )}
                    value={violationTitleInput.trim()}   
                    onInputChange={(event, newInputValue) => {
                        setViolationTitleInput(newInputValue || "");
                        navigate("/dashboard/page/1");
                        setUserCheck(false);
                        setAddCheck(false);
                        setBulkCheck(false);
                        setCurrPage(1);
                    }}
            />
            <select className="sort-dropdown" value={sortValue} onChange={(e) => {setSortValue(e.target.value);}} name="sort-dropdown">
                <option value="">Sort By</option>
                <option value="arsCode-asc">ARS-Code (A-Z)</option>
                <option value="arsCode-desc">ARS-Code (Z-A)</option>
                <option value="startDate-desc">Start Date (Newest)</option>
                <option value="startDate-asc">Start Date (Oldest)</option>
                <option value="fine-desc">Fine (High to Low)</option>
                <option value="fine-asc">Fine (Low to High)</option>
                <option value="proof-info">Proof/Info</option>
            </select>
            
            <div className="header-actions">
                <button className="bulk-edit-button" title="Bulk Edit" onClick={handleBulkCheck}>Bulk Update</button>
                <button
                    className="admin-button"
                    aria-label="admin menu"
                    aria-controls={open ? 'admin-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleMenuClick}>
                    
                    Admin <SlArrowDown style={{position: "absolute", right: "6px", marginTop: "2px", width: "10px", height: "10px"}} />
                </button>

                <Menu id="admin-menu" anchorEl={anchorEl} open={open} onClose={handleMenuClose} PaperProps={{ style: { maxHeight: ITEM_HEIGHT * 4.5, width: '14.8ch', marginTop: "1px"  }}}>
                    {options.map((option) => (
                        <MenuItem
                        style={{
                            maxHeight: ITEM_HEIGHT * 4.5,
                            width: '20ch',
                        }}
                            key={option.name}
                            disabled={option.disabled}
                            onClick={() => {
                                handleMenuChange(option.name);
                                handleMenuClose();
                            }}>

                            {option.name}
                        </MenuItem>
                    ))}
                </Menu>
                                                    
             
                <div className="add-violation-icon"> 
                    <IoIosAdd title="Add Violation" onClick={handleSetAdd}/>
                </div>
            </div>  
        </div>
    )
}
